var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./Join.less');

var JoinBenefits = require('front/components/JoinBenefits/JoinBenefits');
var JoinHowTo = require('front/components/JoinHowTo/JoinHowTo');
var CommonGallery = require('front/components/CommonGallery/CommonGallery');

module.exports = Section.extend({

    el: '.Join',

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'JoinBenefits': {selector: '.JoinBenefits', viewConstructor: JoinBenefits},
        'JoinHowTo': {selector: '.JoinHowTo', viewConstructor: JoinHowTo},
        'CommonGallery': {selector: '.CommonGallery', viewConstructor: CommonGallery}
    },

    events: {
    },


    initialize: function (options) {
        this.options = options || {};

        Section.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Join/Join.js
// module id = 272
// module chunks = 0